module.exports = __webpack_public_path__ + "img/first-1-opened.c42fb9eb.webp";